import { useContext } from "react"
import { IntlContext } from "gatsby-plugin-intl"

// the format message hook
export default function useIntl() {
  const intl = useContext(IntlContext)

  function t(id: string, values?: any) {
    return intl.formatMessage({ id }, values)
  }

  return { ...intl, t }
}
